/* State module for itemperties information, shared across the app. If a page needs to store specific information, use a module for the given page. */

// Mutations and Actions
import BaseModule, { BaseModuleOpts } from '@/store/baseModule';
import actions from './actions';
import mutations from './mutations';

interface CrudModuleOpts<T> extends BaseModuleOpts<T> {
  makeCreateParams;
  makeUpdateParams;
  updateUrl;
}
// utils
export default class CrudModule<T> extends BaseModule<T> {
  constructor(opts: CrudModuleOpts<T>) {
    super(opts);
    this.state = {
      ...this.state,
      newItem: {
        isLoading: false,
        data: null,
        error: null,
      },
      updateItem: {
        isLoading: false,
        data: null,
        error: null,
      },
      deleteItem: {
        isLoading: false,
        data: null,
        error: null,
      },
    };

    this.getters = {
      ...this.getters,
      ...this.crudGetters,
    };

    this.actions = actions({
      makeCreateParams: opts.makeCreateParams,
      makeUpdateParams: opts.makeUpdateParams,
      makeHttpParamsUrl: opts.makeHttpParamsUrl,
      serviceAPI: opts.serviceAPI,
      updateUrl: opts.updateUrl,
      baseModuleActions: this.actions,
    });

    this.mutations = {
      ...this.mutations,
      ...this.crudMutations,
    };
  }

  crudGetters = {
    newItem: (state) => state.newItem.data,
    isLoadingCreate: (state) => state.newItem.isLoading,
    createError: (state) => state.newItem.error,
    updateItem: (state) => state.updateItem.data,
    updateError: (state) => state.updateItem.error,
    isLoadingUpdate: (state) => state.updateItem.isLoading,
    deleteItem: (state) => state.deleteItem.data,
    isLoadingDelete: (state) => state.deleteItem.isLoading,
    deleteError: (state) => state.deleteItem.error,
  };

  crudMutations = mutations;
}
